import { render, staticRenderFns } from "./Inventorydetailed.vue?vue&type=template&id=2332d9be"
import script from "./Inventorydetailed.vue?vue&type=script&lang=js"
export * from "./Inventorydetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports